import {
    ADD_EMPLOEE_ON_HOLD_REQUEST,
    ADD_EMPLOEE_ON_HOLD_SUCCESS,
    ADD_EMPLOEE_ON_HOLD_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const addEmployeeOnHoldReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_EMPLOEE_ON_HOLD_REQUEST:
            return {
                error: "",
                loading: true,
                data: [],
            };

        case ADD_EMPLOEE_ON_HOLD_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case ADD_EMPLOEE_ON_HOLD_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
}

export default addEmployeeOnHoldReducer;
